import { useQuery } from '@tanstack/react-query';
import projectPlanDraftService from '@services/projectPlanDraft';

export const AI_PLANNING_AVAILABLE_QUERY_KEY = 'aiPlanningAvailable';

/** Mirrors `useFieldCaptureEnabled`'s pattern: long stale time, no retry, off entirely when unauthenticated. */
export const useAiPlanningAvailable = () => {
  return useQuery({
    queryKey: [AI_PLANNING_AVAILABLE_QUERY_KEY],
    queryFn: () => projectPlanDraftService.getAiPlanningAvailable(),
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
};

export default useAiPlanningAvailable;
